import styled from '@emotion/styled';

export const Content = styled.article`
    width: 100%;
    min-width: 1260px;
    overflow: hidden;
    font-family: 'Pretendard', sans-serif;
    color: #1d1d1d;
    user-select: text;

    h1,
    h2,
    h3,
    p,
    blockquote {
        margin: 0;
    }
`;

export const Panel = styled.div<{ height: number }>`
    position: relative;
    height: ${({ height }) => height}px;
`;

export const Background = styled.img`
    position: absolute;
    left: 50%;
    top: 0;
    transform: translateX(-50%);
    width: 2560px;
    height: auto;
    max-width: none;
    pointer-events: none;
`;

export const Canvas = styled.div`
    position: relative;
    width: 1260px;
    height: 100%;
    margin: 0 auto;
`;

export const Illustration = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 1260px;
    height: auto;
    pointer-events: none;
`;

/** 시안의 이미지 여백에 맞춰 텍스트만 별도 배치한다. 줄바꿈도 실제 DOM 텍스트다. */
export const Copy = styled.p<{
    top: number;
    left?: number;
    width?: number;
    size?: number;
    weight?: number;
    color?: string;
    leading?: number;
    align?: 'left' | 'center' | 'right';
}>`
    position: absolute;
    top: ${({ top }) => top}px;
    left: ${({ left = 0 }) => left}px;
    width: ${({ width = 1260 }) => width}px;
    font-size: ${({ size = 24 }) => size}px;
    font-weight: ${({ weight = 500 }) => weight};
    line-height: ${({ leading = 1.4 }) => leading};
    text-align: ${({ align = 'center' }) => align};
    white-space: pre-line;
    color: ${({ color = 'inherit' }) => color};

    strong {
        font-weight: 800;
    }
`;

export const Heading = styled(Copy)`
    font-family: 'Paperlogy', 'Pretendard', sans-serif;
    font-weight: 800;
`;

export const Green = styled.span`
    color: #17bc59;
`;

export const Mint = styled.span`
    color: #40e27d;
`;

export const Pink = styled.span`
    color: #fe487b;
`;

/** Paperlogy 50px 기준 ‘캐츠홈’의 폭은 시안에서 132px이다. */
export const ComparisonHighlight = styled.span`
    background: linear-gradient(to right, #17bc59 132px, #0bb24e 132px);
    background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const HeroBadge = styled(Copy)`
    border-radius: 30px;
    background: #17bc59;
    line-height: 38px;
`;

export const Award = styled(Heading)`
    background: linear-gradient(#ffffff 15%, #f8e15d 85%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
`;

export const Step = styled(Copy)`
    border-radius: 30px;
    background: #005bdf;
    line-height: 32px;
    letter-spacing: -0.03em;
`;

/** 테두리와 셀 배경은 원본 비교표 이미지, 내용과 행/열 관계는 HTML 표가 담당한다. */
export const Comparison = styled.table`
    position: absolute;
    top: 210px;
    left: 161px;
    width: 953px;
    table-layout: fixed;
    border-collapse: separate;
    border-spacing: 0;
    text-align: center;
    white-space: pre-line;

    col:nth-of-type(1) {
        width: 230px;
    }
    col:nth-of-type(2) {
        width: 404px;
    }
    col:nth-of-type(3) {
        width: 319px;
    }
    thead th {
        height: 75px;
        font-size: 24px;
        font-weight: 800;
        line-height: 1.4;
        color: #1e1e1e;
        vertical-align: middle;
    }
    thead th:nth-of-type(2) {
        color: #fff;
        font-size: 40px;
        font-weight: 900;
        line-height: 1.52;
    }
    thead th:nth-of-type(3) {
        color: #2e2e2e;
        font-weight: 700;
    }
    tbody th,
    tbody td {
        height: 167px;
        padding: 0;
        box-sizing: border-box;
        vertical-align: middle;
    }
    tbody th {
        font-size: 20px;
        line-height: 1.4;
        font-weight: 800;
    }
    td:nth-of-type(1) {
        font-size: 20px;
        font-weight: 600;
        line-height: 1.4;
    }
    td:nth-of-type(2) {
        color: #878787;
        font-size: 18px;
        font-weight: 500;
        line-height: 1.4;
    }
    small {
        color: #8e8e8e;
        font-size: 16px;
        font-weight: 400;
    }
`;

/** 비교 기호는 시안의 벡터 치수를 사용해 글꼴에 따른 모양 차이를 없앤다. */
export const ComparisonMark = styled.svg<{ positive?: boolean }>`
    display: block;
    margin: 0 auto ${({ positive }) => (positive ? 12.81 : 8.54)}px;
    width: ${({ positive }) => (positive ? 40.13 : 47)}px;
    height: ${({ positive }) => (positive ? 40.13 : 47)}px;
    fill: none;
    stroke: ${({ positive }) => (positive ? '#0bb24e' : '#4f4f4f')};
    stroke-width: 3;
    stroke-linejoin: round;
`;
